/**
 * React Native Storage Adapter
 * @module @one-payments/adapters-native
 */

import AsyncStorage from '@react-native-async-storage/async-storage';
import type { StorageAdapter } from '@one-payments/core';

/**
 * Native Storage Adapter using AsyncStorage
 */
export class NativeStorageAdapter implements StorageAdapter {
  private readonly prefix: string;

  constructor(prefix = 'one-payments:') {
    this.prefix = prefix;
  }

  public async get(key: string): Promise<string | null> {
    return await AsyncStorage.getItem(this.prefix + key);
  }

  public async set(key: string, value: string): Promise<void> {
    await AsyncStorage.setItem(this.prefix + key, value);
  }

  public async remove(key: string): Promise<void> {
    await AsyncStorage.removeItem(this.prefix + key);
  }

  public async clear(): Promise<void> {
    const keys = await AsyncStorage.getAllKeys();
    const keysToRemove = keys.filter((key) => key.startsWith(this.prefix));
    await AsyncStorage.multiRemove(keysToRemove);
  }
}
